"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockchainExplorer = exports.getBlockchainConnectorByConfig = exports.getBlockchainConnectorByName = exports.getBlockchainConnectors = exports.getBlockchainOfflineConnector = exports.getBlockchainOfflineConnectors = exports.getBlockchainWalletConnectors = exports.getBlockchainConfig = void 0;
const Blockchains_1 = require("./Blockchains");
const Array_1 = require("./Utils/Array");
const getBlockchainConfig = (blockchain) => {
    const config = Blockchains_1.blockchainConfigMap[blockchain];
    if (config) {
        return config;
    }
    throw new Error(`Blockchain config not found for ${blockchain}`);
};
exports.getBlockchainConfig = getBlockchainConfig;
const getBlockchainWalletConnectors = (blockchain) => {
    return exports.getBlockchainConfig(blockchain).wallets;
};
exports.getBlockchainWalletConnectors = getBlockchainWalletConnectors;
const getBlockchainOfflineConnectors = (blockchain) => {
    return exports.getBlockchainConfig(blockchain).offlineConnectors;
};
exports.getBlockchainOfflineConnectors = getBlockchainOfflineConnectors;
const getBlockchainOfflineConnector = (blockchain, _options = {}) => {
    const { random } = Object.assign({ random: false }, _options);
    const { offlineConnectors } = exports.getBlockchainConfig(blockchain);
    return random ? Array_1.randomItem(offlineConnectors) : offlineConnectors[0];
};
exports.getBlockchainOfflineConnector = getBlockchainOfflineConnector;
const getBlockchainConnectors = (blockchain) => {
    const config = exports.getBlockchainConfig(blockchain);
    return [...config.wallets, ...config.offlineConnectors];
};
exports.getBlockchainConnectors = getBlockchainConnectors;
const getBlockchainConnectorByName = (blockchain, connectorName) => {
    return exports.getBlockchainConnectors(blockchain).find((connector) => connector.name === connectorName);
};
exports.getBlockchainConnectorByName = getBlockchainConnectorByName;
const getBlockchainConnectorByConfig = (blockchain, { metadata, params }) => {
    const config = exports.getBlockchainConfig(blockchain);
    if (!config.connectorFactory) {
        throw new Error(`Blockchain ${blockchain} custom connector factory not supported`);
    }
    return config.connectorFactory(config, metadata, params);
};
exports.getBlockchainConnectorByConfig = getBlockchainConnectorByConfig;
const getBlockchainExplorer = (blockchain) => {
    return exports.getBlockchainConfig(blockchain).explorer;
};
exports.getBlockchainExplorer = getBlockchainExplorer;
